import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import Login from './login/Login';
import Layout from "./Layout";
import ProfileComponent from "./Components/ProfileComponent";
import PayementComponent from "./Components/PayementComponent ";
import CreditMenuComponent from "./Components/CreditMenuComponent ";
import ManageSellerComponent from "./Components/ManageSellerComponent ";
import ManagePinComponent from "./Components/ManagePinComponent ";


const App: React.FC = () => {
    const [loading, setLoading] = useState(true);
    const [authenticated, setAuthenticated] = useState(false);
    const [userRole,setUserRole] = useState("");


    useEffect(()=>{},[userRole,authenticated]);

    useEffect(() => {

        const token = localStorage.getItem('token');

        if (token) {

            const headers = {
                Authorization: `Bearer ${token}`,
            };


            fetch('/api/v1/role', { headers })
                .then((response) => {
                    if (response.ok) {

                        response.json().then((data)=>{
                            if(data.userStatus === "BANNED"){
                                setAuthenticated(false);
                            }
                            else {
                                setUserRole(data.role);
                                setAuthenticated(true);
                            }


                        })



                       // User is authenticated
                    } else {
                        setAuthenticated(false); // User is not authenticated
                    }
                })
                .catch((error) => {
                    console.error('Error occurred while fetching user data', error);
                    setAuthenticated(false);
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            setLoading(false);
        }
    }, []);

    return (
        <Router>
            {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                    <CircularProgress color="primary" size={60} />
                </div>
            ) : (
                <Routes>
                    <Route
                        path="/login"
                        element={authenticated ? <Navigate to="/home" /> : <Login onLogin={()=>{}} />}
                    />


                    <Route
                        path="/home"
                        element={authenticated ? <Layout children={<ProfileComponent role={userRole}/> } role={userRole}/> : <Navigate to="/login" />}
                    >
                        {/*<Route path="profile" element={<Layout children={<ProfileComponent/>}/>} />*/}
                        {/*<Route path="creditmenu" element={<Layout children={<CreditMenuComponent/>}/>} />*/}
                        {/*<Route path="payment" element={<Layout children={<PayementComponent/>}/>} />*/}
                        {/*<Route path="manage-seller" element={<Layout children={<ManageSellerComponent/>}/>} />*/}
                        {/*<Route path="manage-pin" element={<Layout children={<ManagePinComponent/>}/>} />*/}

                    </Route>
                    <Route
                        path="/creditmenu"
                        element={authenticated ? <Layout children={<CreditMenuComponent/>} role={userRole}/> : <Navigate to="/login" />}
                    />
                    <Route
                        path="/payment"
                        element={authenticated ? <Layout children={<PayementComponent/>} role={userRole}/> : <Navigate to="/login" />}
                    />


                    <Route
                        path="/manage-seller"
                        element={authenticated ? <Layout children={<ManageSellerComponent/> } role={userRole}/> : <Navigate to="/login" />}
                    />
                    <Route
                        path="/manage-pin"
                        element={authenticated ? <Layout children={<ManagePinComponent/>} role={userRole}/> : <Navigate to="/login" />}
                    />





                    <Route
                        path="/"
                        element={<Navigate to="/login" />}
                    />
                </Routes>
            )}
        </Router>
    );
};

export default App;